import { render } from "./invoiceHeader.vue?vue&type=template&id=24e4d904&scoped=true"
import script from "./invoiceHeader.vue?vue&type=script&lang=js"
export * from "./invoiceHeader.vue?vue&type=script&lang=js"

import "./invoiceHeader.vue?vue&type=style&index=0&id=24e4d904&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e4d904"]])

export default __exports__